package com.eladfinish.bible.contest.platform.audio

import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.analytics.crashlytics.AppCrashlytics
import com.eladfinish.bible.contest.correct_answer_bell_gliss_mp3
import com.eladfinish.bible.contest.correct_answer_double_mp3
import com.eladfinish.bible.contest.neck_snap_mp3
import com.eladfinish.bible.contest.wrong_answer_wav
import dev.icerock.moko.resources.FileResource
import org.w3c.dom.Audio

class WebSoundPlayer : SoundPlayer {
    override fun play(effect: SoundEffect) {
        val fileResource = when (effect) {
            SoundEffect.CORRECT -> SharedRes.files.correct_answer_double_mp3
            SoundEffect.WRONG -> SharedRes.files.wrong_answer_wav
            SoundEffect.TIME_UP -> SharedRes.files.neck_snap_mp3
            SoundEffect.SUCCESS -> SharedRes.files.correct_answer_bell_gliss_mp3
        }

        play(fileResource)
    }

    override fun play(fileResource: FileResource) {
        try {
            Audio(fileResource.fileUrl).play().catch {
                AppCrashlytics.logException(RuntimeException(it.toString()))
            }
        } catch (t: Throwable) {
            AppCrashlytics.logException(t)
        }
    }
}
